<div class="header-bar">
  <h1>Postcode Weighting</h1>
</div>

<p-tabView class="tab-padding no-widget-border">
  <p-tabPanel header="Postcodes">
    <manage-postcodes-weight [isPricingAdmin]="isPricingAdmin"></manage-postcodes-weight>
  </p-tabPanel>
  <p-tabPanel header="Premiums">
    <manage-premiums [isPricingAdmin]="isPricingAdmin"></manage-premiums>
  </p-tabPanel>
</p-tabView>

<ng-template #loading>Loading...</ng-template>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
